'use strict';

const edgeConfig = {
  basePath: "/api/.ory",
  baseOptions: {
    withCredentials: true
  }
};

exports.edgeConfig = edgeConfig;
//# sourceMappingURL=index.js.map
